import React from "react";
import { Routes, Route } from "react-router-dom";
import { PATH } from "../constants/routes";
import Slider from "../pages/Slider/Slider";
import AddSlider from "../pages/Slider/AddSlider";

export default function FeedbackRoute() {
  return (
    <Routes>
      <Route index element={<Slider />} />
      <Route path={PATH.ADD_SLIDER} element={<AddSlider />} />
    </Routes>
  );
}
